import { PopUp } from './PopUp'

export class EnrichmentApi {
  form?: HTMLFormElement
  routingId?: string
  emailField?: HTMLInputElement | null
  fieldNamesToEnrich?: string[]
  emailFieldName?: string
  enrichmentParentDivClassName?: string
  fieldElementsToEnrich?: NodeListOf<HTMLElement>
  CPPopUp?: PopUp
  constructor(form?: HTMLFormElement, CPPopUp?: PopUp) {
    this.setForm(form)
    this.setCPPopUp(CPPopUp)
    this.addEnrichmentListeners()
  }

  setCPPopUp = (CPPopUp?: PopUp) => {
    this.CPPopUp = CPPopUp
  }

  setForm = (form?: HTMLFormElement) => {
    this.form = form
    this.hideEnrichmentFields()
  }

  updateEnrichmentFields = ({
    fieldsToEnrich = [],
    emailField,
  }: {
    fieldsToEnrich: string[]
    emailField?: string
  }) => {
    this.emailFieldName = emailField
    this.fieldNamesToEnrich = fieldsToEnrich
    this.hideEnrichmentFields()
  }

  // Here we will find the input and label elements to hide
  // And send to booking app the email value once it gets blurred
  hideEnrichmentFields = () => {
    if (this.form && this.fieldNamesToEnrich?.length && this.emailFieldName) {
      this.emailField = this.form.querySelector<HTMLInputElement>(
        `input[name="${this.emailFieldName}"]`
      )
      if (this.emailField) {
        const fieldsToEnrichSelector = this.fieldNamesToEnrich.reduce((acc, fieldId) => {
          return `${acc ? `${acc}, ` : ''}label[for*="${fieldId}"], input[id="${fieldId}"], input[name="${fieldId}"], select[id="${fieldId}"], select[name="${fieldId}"]`
        }, '')
        this.fieldElementsToEnrich = this.form.querySelectorAll<HTMLElement>(fieldsToEnrichSelector)
        this.fieldElementsToEnrich?.forEach(field => {
          if (this.enrichmentParentDivClassName) {
            const div = field.closest<HTMLDivElement>(this.enrichmentParentDivClassName)
            if (div) {
              div.style.display = 'none'
            }
          }
          field.style.display = 'none'
          if ('value' in field) {
            field.value = ''
          }
        })
        const onEmailBlur = () => {
          const eventData = { type: 'ENRICH_CONCIERGE_FORM_DATA', data: this.emailField?.value }
          if (this.CPPopUp?.iframe) {
            this.CPPopUp.iframe.contentWindow?.postMessage(eventData, '*')
          } else if (window.self !== window.top) {
            window.top?.postMessage(eventData, '*')
          }
        }
        this.emailField.onblur = onEmailBlur
      }
    }
  }

  // When the enrichment API is called with the email value
  // This function properly shows back or Pkeeps fields hidden
  onEnrichData = ({
    enrichedFields,
    routingId,
  }: {
    enrichedFields: Record<string, string>
    routingId?: string
  }) => {
    this.routingId = routingId
    this.fieldElementsToEnrich?.forEach(field => {
      const fieldValue = (() => {
        if ('name' in field && typeof field.name === 'string') {
          return enrichedFields[field.name]
        }
        // We should show bakc labels too
        if (field.hasAttribute('for')) {
          const fieldId = Object.keys(enrichedFields).find(fieldId =>
            field.getAttribute('for')?.includes(fieldId)
          )
          return fieldId ? enrichedFields[fieldId] : undefined
        }
        return enrichedFields[field.id]
      })()
      // Adds the value to the field so third party validations work
      if ('value' in field) {
        field.value = fieldValue || ''
        field.setAttribute('data-enriched', 'true')
      }

      if (field.hasAttribute('required')) {
        field.setAttribute('data-required', 'true')
        field.removeAttribute('required')
      }

      // If we couldn't enrich the data, we show it back
      if (!fieldValue) {
        if (this.enrichmentParentDivClassName) {
          const div = field.closest<HTMLDivElement>(this.enrichmentParentDivClassName)
          if (div) {
            div.style.display = ''
          }
        }
        field.style.display = ''

        // If the field is required, we need to put it back as required
        if (field.hasAttribute('data-required')) {
          field.setAttribute('required', 'true')
          field.removeAttribute('data-required')
        }

        if (field.hasAttribute('data-enriched')) {
          field.removeAttribute('data-enriched')
        }
      } else {
        if (this.enrichmentParentDivClassName) {
          const div = field.closest<HTMLDivElement>(this.enrichmentParentDivClassName)
          if (div) {
            div.style.display = 'none'
          }
        }
        field.style.display = 'none'

        // If the field is required, we need to remove required as it was enriched and no value is there
        if (field.hasAttribute('required')) {
          field.setAttribute('data-required', 'true')
          field.removeAttribute('required')
        }
      }
    })
  }

  onMessage = (event: MessageEvent) => {
    if (event.data.action === 'hide-enrichment-fields') {
      this.updateEnrichmentFields(event.data.args)
    } else if (event.data.action === 'enrichment-succeeded') {
      this.onEnrichData(event.data.args)
    }
  }

  addEnrichmentListeners = () => {
    window.addEventListener('message', this.onMessage, false)
  }

  removeEventListeners = () => {
    window.removeEventListener('message', this.onMessage)
  }
}
